import {
  EMPLOYEES_LIST_FAIL,
  EMPLOYEES_LIST_REQUEST,
  EMPLOYEES_LIST_SUCCESS,
  EMPLOYEES_USER_ID_LIST_FAIL,
  EMPLOYEES_USER_ID_LIST_REQUEST,
  EMPLOYEES_USER_ID_LIST_SUCCESS,
  EMPLOYEES_INVITE_BY_EMAIL_FAIL,
  EMPLOYEES_INVITE_BY_EMAIL_REQUEST,
  EMPLOYEES_INVITE_BY_EMAIL_SUCCESS,
  EMPLOYEES_ALL_SCREENSHOT_FAIL,
  EMPLOYEES_ALL_SCREENSHOT_REQUEST,
  EMPLOYEES_ALL_SCREENSHOT_SUCCESS,
  EMPLOYEES_ALL_FAIL,
  EMPLOYEES_ALL_REQUEST,
  EMPLOYEES_ALL_SUCCESS,
  EMPLOYEES_ALL_ACTIVITY_FAIL,
  EMPLOYEES_ALL_ACTIVITY_REQUEST,
  EMPLOYEES_ALL_ACTIVITY_SUCCESS,
  EMPLOYEES_ALL_REPORT_FAIL,
  EMPLOYEES_ALL_REPORT_REQUEST,
  EMPLOYEES_ALL_REPORT_SUCCESS,
  EMPLOYEES_ALL_TIMESHEET_FAIL,
  EMPLOYEES_ALL_TIMESHEET_REQUEST,
  EMPLOYEES_ALL_TIMESHEET_SUCCESS,
  EMPLOYEES_ADD_TIME_IN_PROJECT_FAIL,
  EMPLOYEES_ADD_TIME_IN_PROJECT_REQUEST,
  EMPLOYEES_ADD_TIME_IN_PROJECT_SUCCESS,
  EMPLOYEES_ALL_TEAMS_FAIL,
  EMPLOYEES_ALL_TEAMS_REQUEST,
  EMPLOYEES_ALL_TEAMS_SUCCESS,
  ADD_ONE_EMPLOYEE_IN_PROJECT_FAIL,
  ADD_ONE_EMPLOYEE_IN_PROJECT_REQUEST,
  ADD_ONE_EMPLOYEE_IN_PROJECT_SUCCESS,
  ADD_ONE_EMPLOYEE_IN_PROJECT_ID_FAIL,
  ADD_ONE_EMPLOYEE_IN_PROJECT_ID_REQUEST,
  ADD_ONE_EMPLOYEE_IN_PROJECT_ID_SUCCESS,
  EMPLOYEE_TIMEPRO_DATE_FAIL,
  EMPLOYEE_TIMEPRO_DATE_REQUEST,
  EMPLOYEE_TIMEPRO_DATE_SUCCESS,
  EMPLOYEE_TIMEPRO_WEEK_FAIL,
  EMPLOYEE_TIMEPRO_WEEK_REQUEST,
  EMPLOYEE_TIMEPRO_WEEK_SUCCESS,
  EMPLOYEE_TIMEPRO_SEVEN_FAIL,
  EMPLOYEE_TIMEPRO_SEVEN_REQUEST,
  EMPLOYEE_TIMEPRO_SEVEN_SUCCESS,
  EMPLOYEES_ALL_CHECKIN_FAIL,
  EMPLOYEES_ALL_CHECKIN_REQUEST,
  EMPLOYEES_ALL_CHECKIN_SUCCESS,
  EMPLOYEES_EDIT_TIME_IN_PROJECT_FAIL,
  EMPLOYEES_EDIT_TIME_IN_PROJECT_REQUEST,
  EMPLOYEES_EDIT_TIME_IN_PROJECT_SUCCESS,
  EMPLOYEES_BLOCK_FROM_COMPANY_FAIL,
  EMPLOYEES_BLOCK_FROM_COMPANY_REQUEST,
  EMPLOYEES_BLOCK_FROM_COMPANY_SUCCESS,
  EMPLOYEES_DELETE_FROM_COMPANY_FAIL,
  EMPLOYEES_DELETE_FROM_COMPANY_REQUEST,
  EMPLOYEES_DELETE_FROM_COMPANY_SUCCESS,
  EMPLOYEES_BLOCK_FROM_DEPARTMENT_FAIL,
  EMPLOYEES_BLOCK_FROM_DEPARTMENT_REQUEST,
  EMPLOYEES_BLOCK_FROM_DEPARTMENT_SUCCESS,
  UPDATE_EMPLOYEE_DETAILS_FAIL,
  UPDATE_EMPLOYEE_DETAILS_REQUEST,
  UPDATE_EMPLOYEE_DETAILS_SUCCESS,
  DELETE_PROJECT_TIME_OF_EMPLOYEE_FAIL,
  DELETE_PROJECT_TIME_OF_EMPLOYEE_REQUEST,
  DELETE_PROJECT_TIME_OF_EMPLOYEE_SUCCESS,
  SEND_OTP_EMAIL_BY_ADMIN_FAIL,
  SEND_OTP_EMAIL_BY_ADMIN_REQUEST,
  SEND_OTP_EMAIL_BY_ADMIN_SUCCESS,
  DELETE_SCREENSHOT_FAIL,
  DELETE_SCREENSHOT_REQUEST,
  DELETE_SCREENSHOT_SUCCESS,
  UPDATE_REASON_IN_EMP_SCREENSHOT_FAIL,
  UPDATE_REASON_IN_EMP_SCREENSHOT_REQUEST,
  UPDATE_REASON_IN_EMP_SCREENSHOT_SUCCESS,
  ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_FAIL,
  ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_REQUEST,
  ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_SUCCESS,
  EMPLOYEES_MANAGER_TOTAL_TIME_BY_RANGE_FAIL,
  EMPLOYEES_MANAGER_TOTAL_TIME_BY_RANGE_REQUEST,
  EMPLOYEES_MANAGER_TOTAL_TIME_BY_RANGE_SUCCESS
} from "../../types/manager/employessTypes";

export const empDepListReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEES_LIST_REQUEST:
      return {
        ...state,
        loadings: true,
      };
    case EMPLOYEES_LIST_SUCCESS:
      return {
        ...state,
        loadings: false,
        employeesList: payload,
        errors: "",
      };
    case EMPLOYEES_LIST_FAIL:
      return {
        ...state,
        loadings: false,
        errors: payload,
        employeesList: [],
      };
    default:
      return state;
  }
};

export const empDepUserIdReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEES_USER_ID_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EMPLOYEES_USER_ID_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        employeesId: payload,
        error: "",
      };
    case EMPLOYEES_USER_ID_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        employeesId: [],
      };
    default:
      return state;
  }
};

export const empDepInviteByEmailReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEES_INVITE_BY_EMAIL_REQUEST:
      return {
        ...state,
        inviteLoading: true,
      };
    case EMPLOYEES_INVITE_BY_EMAIL_SUCCESS:
      return {
        ...state,
        inviteLoading: false,
        inviteInfo: payload,
        inviteError: "",
      };
    case EMPLOYEES_INVITE_BY_EMAIL_FAIL:
      return {
        ...state,
        inviteLoading: false,
        inviteError: payload,
        inviteInfo: [],
      };
    default:
      return state;
  }
};

export const empDepAllScreenReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEES_ALL_SCREENSHOT_REQUEST:
      return {
        ...state,
        allScreenLoading: true,
      };
    case EMPLOYEES_ALL_SCREENSHOT_SUCCESS:
      return {
        ...state,
        allScreenLoading: false,
        allScreenInfo: payload,
        allScreenError: "",
      };
    case EMPLOYEES_ALL_SCREENSHOT_FAIL:
      return {
        ...state,
        allScreenLoading: false,
        allScreenError: payload,
        allScreenInfo: [],
      };
    default:
      return state;
  }
};

export const empDepAllReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEES_ALL_REQUEST:
      return {
        ...state,
        allEmpLoading: true,
      };
    case EMPLOYEES_ALL_SUCCESS:
      return {
        ...state,
        allEmpLoading: false,
        allEmpInfo: payload,
        allEmpError: "",
      };
    case EMPLOYEES_ALL_FAIL:
      return {
        ...state,
        allEmpLoading: false,
        allEmpError: payload,
        allEmpInfo: [],
      };
    default:
      return state;
  }
};

export const empDepAllActivityReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEES_ALL_ACTIVITY_REQUEST:
      return {
        ...state,
        allEmpActLoading: true,
      };
    case EMPLOYEES_ALL_ACTIVITY_SUCCESS:
      return {
        ...state,
        allEmpActLoading: false,
        allEmpActInfo: payload,
        allEmpActError: "",
      };
    case EMPLOYEES_ALL_ACTIVITY_FAIL:
      return {
        ...state,
        allEmpActLoading: false,
        allEmpActError: payload,
        allEmpActInfo: [],
      };
    default:
      return state;
  }
};

export const empDepAllReportReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEES_ALL_REPORT_REQUEST:
      return {
        ...state,
        allEmpRepLoading: true,
      };
    case EMPLOYEES_ALL_REPORT_SUCCESS:
      return {
        ...state,
        allEmpRepLoading: false,
        allEmpRepInfo: payload,
        allEmpRepError: "",
      };
    case EMPLOYEES_ALL_REPORT_FAIL:
      return {
        ...state,
        allEmpRepLoading: false,
        allEmpRepError: payload,
        allEmpRepInfo: [],
      };
    default:
      return state;
  }
};

export const empDepAllTimesheetReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEES_ALL_TIMESHEET_REQUEST:
      return {
        ...state,
        allEmpSheetLoading: true,
      };
    case EMPLOYEES_ALL_TIMESHEET_SUCCESS:
      return {
        ...state,
        allEmpSheetLoading: false,
        allEmpSheetInfo: payload,
        allEmpSheetError: "",
      };
    case EMPLOYEES_ALL_TIMESHEET_FAIL:
      return {
        ...state,
        allEmpSheetLoading: false,
        allEmpSheetError: payload,
        allEmpSheetInfo: [],
      };
    default:
      return state;
  }
};

export const empDepAllTeamsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEES_ALL_TEAMS_REQUEST:
      return {
        ...state,
        allEmpTeamsLoading: true,
      };
    case EMPLOYEES_ALL_TEAMS_SUCCESS:
      return {
        ...state,
        allEmpTeamsLoading: false,
        allEmpTeamsInfo: payload,
        allEmpTeamsError: "",
      };
    case EMPLOYEES_ALL_TEAMS_FAIL:
      return {
        ...state,
        allEmpTeamsLoading: false,
        allEmpTeamsError: payload,
        allEmpTeamsInfo: [],
      };
    default:
      return state;
  }
};

export const empDepAddTimeInProjectReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEES_ADD_TIME_IN_PROJECT_REQUEST:
      return {
        ...state,
        addEmpTimeLoading: true,
      };
    case EMPLOYEES_ADD_TIME_IN_PROJECT_SUCCESS:
      return {
        ...state,
        addEmpTimeLoading: false,
        addEmpTimeInfo: payload,
        addEmpTimeError: "",
      };
    case EMPLOYEES_ADD_TIME_IN_PROJECT_FAIL:
      return {
        ...state,
        addEmpTimeLoading: false,
        addEmpTimeError: payload,
        addEmpTimeInfo: [],
      };
    default:
      return state;
  }
};

export const empDepEditTimeInProjectReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEES_EDIT_TIME_IN_PROJECT_REQUEST:
      return {
        ...state,
        editEmpTimeLoading: true,
      };
    case EMPLOYEES_EDIT_TIME_IN_PROJECT_SUCCESS:
      return {
        ...state,
        editEmpTimeLoading: false,
        editEmpTimeInfo: payload,
        editEmpTimeError: "",
      };
    case EMPLOYEES_EDIT_TIME_IN_PROJECT_FAIL:
      return {
        ...state,
        editEmpTimeLoading: false,
        editEmpTimeError: payload,
        editEmpTimeInfo: [],
      };
    default:
      return state;
  }
};

export const empDepAddInProjectReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_ONE_EMPLOYEE_IN_PROJECT_REQUEST:
      return {
        ...state,
        addProjectLoading: true,
      };
    case ADD_ONE_EMPLOYEE_IN_PROJECT_SUCCESS:
      return {
        ...state,
        addProjectLoading: false,
        addProjectInfo: payload,
        addProjectError: "",
      };
    case ADD_ONE_EMPLOYEE_IN_PROJECT_FAIL:
      return {
        ...state,
        addProjectLoading: false,
        addProjectError: payload,
        addProjectInfo: [],
      };
    default:
      return state;
  }
};

export const empDepAddInProjectIdReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_ONE_EMPLOYEE_IN_PROJECT_ID_REQUEST:
      return {
        ...state,
        addEmpProjectIdLoading: true,
      };
    case ADD_ONE_EMPLOYEE_IN_PROJECT_ID_SUCCESS:
      return {
        ...state,
        addEmpProjectIdLoading: false,
        addEmpProjectIdInfo: payload,
        addEmpProjectIdError: "",
      };
    case ADD_ONE_EMPLOYEE_IN_PROJECT_ID_FAIL:
      return {
        ...state,
        addEmpProjectIdLoading: false,
        addEmpProjectIdError: payload,
        addEmpProjectIdInfo: [],
      };
    default:
      return state;
  }
};

export const empDepTimeProDasboardDateReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEE_TIMEPRO_DATE_REQUEST:
      return {
        ...state,
        empTimeProDashDateLoading: true,
      };
    case EMPLOYEE_TIMEPRO_DATE_SUCCESS:
      return {
        ...state,
        empTimeProDashDateLoading: false,
        empTimeProDashDateInfo: payload,
        empTimeProDashDateError: "",
      };
    case EMPLOYEE_TIMEPRO_DATE_FAIL:
      return {
        ...state,
        empTimeProDashDateLoading: false,
        empTimeProDashDateError: payload,
        empTimeProDashDateInfo: [],
      };
    default:
      return state;
  }
};

export const empDepTimeProDasboardWeekReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEE_TIMEPRO_WEEK_REQUEST:
      return {
        ...state,
        empTimeProDashWeekLoading: true,
      };
    case EMPLOYEE_TIMEPRO_WEEK_SUCCESS:
      return {
        ...state,
        empTimeProDashWeekLoading: false,
        empTimeProDashWeekInfo: payload,
        empTimeProDashWeekError: "",
      };
    case EMPLOYEE_TIMEPRO_WEEK_FAIL:
      return {
        ...state,
        empTimeProDashWeekLoading: false,
        empTimeProDashWeekError: payload,
        empTimeProDashWeekInfo: [],
      };
    default:
      return state;
  }
};

export const empDepTimeProDasboardSevenReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEE_TIMEPRO_SEVEN_REQUEST:
      return {
        ...state,
        empTimeProDashSevenLoading: true,
      };
    case EMPLOYEE_TIMEPRO_SEVEN_SUCCESS:
      return {
        ...state,
        empTimeProDashSevenLoading: false,
        empTimeProDashSevenInfo: payload,
        empTimeProDashSevenError: "",
      };
    case EMPLOYEE_TIMEPRO_SEVEN_FAIL:
      return {
        ...state,
        empTimeProDashSevenLoading: false,
        empTimeProDashSevenError: payload,
        empTimeProDashSevenInfo: [],
      };
    default:
      return state;
  }
};

export const empDepAllCheckinReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEES_ALL_CHECKIN_REQUEST:
      return {
        ...state,
        empAllCheckLoading: true,
      };
    case EMPLOYEES_ALL_CHECKIN_SUCCESS:
      return {
        ...state,
        empAllCheckLoading: false,
        empAllCheckInfo: payload,
        empAllCheckError: "",
      };
    case EMPLOYEES_ALL_CHECKIN_FAIL:
      return {
        ...state,
        empAllCheckLoading: false,
        empAllCheckError: payload,
        empAllCheckInfo: [],
      };
    default:
      return state;
  }
};

export const empDepBlockFromCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEES_BLOCK_FROM_COMPANY_REQUEST:
      return {
        ...state,
        blockEmpLoading: true,
      };
    case EMPLOYEES_BLOCK_FROM_COMPANY_SUCCESS:
      return {
        ...state,
        blockEmpLoading: false,
        blockEmpInfo: payload,
        blockEmpError: "",
      };
    case EMPLOYEES_BLOCK_FROM_COMPANY_FAIL:
      return {
        ...state,
        blockEmpLoading: false,
        blockEmpError: payload,
        blockEmpInfo: [],
      };
    default:
      return state;
  }
};

export const empDepDeleteFromCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEES_DELETE_FROM_COMPANY_REQUEST:
      return {
        ...state,
        deleteEmpLoading: true,
      };
    case EMPLOYEES_DELETE_FROM_COMPANY_SUCCESS:
      return {
        ...state,
        deleteEmpLoading: false,
        deleteEmpInfo: payload,
        deleteEmpError: "",
      };
    case EMPLOYEES_DELETE_FROM_COMPANY_FAIL:
      return {
        ...state,
        deleteEmpLoading: false,
        deleteEmpError: payload,
        deleteEmpInfo: [],
      };
    default:
      return state;
  }
};

export const empDepBlockFromDepartmentReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEES_BLOCK_FROM_DEPARTMENT_REQUEST:
      return {
        ...state,
        blockEmpDepartLoading: true,
      };
    case EMPLOYEES_BLOCK_FROM_DEPARTMENT_SUCCESS:
      return {
        ...state,
        blockEmpDepartLoading: false,
        blockEmpDepartInfo: payload,
        blockEmpDepartError: "",
      };
    case EMPLOYEES_BLOCK_FROM_DEPARTMENT_FAIL:
      return {
        ...state,
        blockEmpDepartLoading: false,
        blockEmpDepartError: payload,
        blockEmpDepartInfo: [],
      };
    default:
      return state;
  }
};

export const empDepUpdatDetailReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_EMPLOYEE_DETAILS_REQUEST:
      return {
        ...state,
        updateEmpDetailLoading: true,
      };
    case UPDATE_EMPLOYEE_DETAILS_SUCCESS:
      return {
        ...state,
        updateEmpDetailLoading: false,
        updateEmpDetailInfo: payload,
        updateEmpDetailError: "",
      };
    case UPDATE_EMPLOYEE_DETAILS_FAIL:
      return {
        ...state,
        updateEmpDetailLoading: false,
        updateEmpDetailError: payload,
        updateEmpDetailInfo: [],
      };
    default:
      return state;
  }
};

export const empDepDeleteProjectTimeReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case DELETE_PROJECT_TIME_OF_EMPLOYEE_REQUEST:
      return {
        ...state,
        delEmpProTimeLoading: true,
      };
    case DELETE_PROJECT_TIME_OF_EMPLOYEE_SUCCESS:
      return {
        ...state,
        delEmpProTimeLoading: false,
        delEmpProTimeInfo: payload,
        delEmpProTimeError: "",
      };
    case DELETE_PROJECT_TIME_OF_EMPLOYEE_FAIL:
      return {
        ...state,
        delEmpProTimeLoading: false,
        delEmpProTimeError: payload,
        delEmpProTimeInfo: [],
      };
    default:
      return state;
  }
};

export const sendDepEmpResetPassEmailReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case SEND_OTP_EMAIL_BY_ADMIN_REQUEST:
      return {
        ...state,
        sendResetPassEmpLoading: true,
      };
    case SEND_OTP_EMAIL_BY_ADMIN_SUCCESS:
      return {
        ...state,
        sendResetPassEmpLoading: false,
        sendResetPassEmpInfo: payload,
        sendResetPassEmpError: "",
      };
    case SEND_OTP_EMAIL_BY_ADMIN_FAIL:
      return {
        ...state,
        sendResetPassEmpLoading: false,
        sendResetPassEmpError: payload,
        sendResetPassEmpInfo: [],
      };
    default:
      return state;
  }
};

export const updateDepEmpScreenShotReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_REASON_IN_EMP_SCREENSHOT_REQUEST:
      return {
        ...state,
        updateScreenEmpLoading: true,
      };
    case UPDATE_REASON_IN_EMP_SCREENSHOT_SUCCESS:
      return {
        ...state,
        updateScreenEmpLoading: false,
        updateScreenEmpInfo: payload,
        updateScreenEmpError: "",
      };
    case UPDATE_REASON_IN_EMP_SCREENSHOT_FAIL:
      return {
        ...state,
        updateScreenEmpLoading: false,
        updateScreenEmpError: payload,
        updateScreenEmpInfo: [],
      };
    default:
      return state;
  }
};

export const deleteDepEmpScreenShotReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case DELETE_SCREENSHOT_REQUEST:
      return {
        ...state,
        deleteScreenEmpLoading: true,
      };
    case DELETE_SCREENSHOT_SUCCESS:
      return {
        ...state,
        deleteScreenEmpLoading: false,
        deleteScreenEmpInfo: payload,
        deleteScreenEmpError: "",
      };
    case DELETE_SCREENSHOT_FAIL:
      return {
        ...state,
        deleteScreenEmpLoading: false,
        deleteScreenEmpError: payload,
        deleteScreenEmpInfo: [],
      };
    default:
      return state;
  }
};

export const addEmpInDepartmentWithProReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_REQUEST:
      return {
        ...state,
        addUserDepartWProLoading: true,
      };
    case ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_SUCCESS:
      return {
        ...state,
        addUserDepartWProLoading: false,
        addUserDepartWProInfo: payload,
        addUserDepartWProError: '',
      };
    case ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_FAIL:
      return {
        ...state,
        addUserDepartWProLoading: false,
        addUserDepartWProError: payload,
        addUserDepartWProInfo: {},
      };
    default:
      return state;
  }
};

//get total time report for payroll by range
export const getManagerEmpTotalTimeByRangeReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEES_MANAGER_TOTAL_TIME_BY_RANGE_REQUEST:
      return {
        ...state,
        getEmpTotalTimeLoading: true,
      };
    case EMPLOYEES_MANAGER_TOTAL_TIME_BY_RANGE_SUCCESS:
      return {
        ...state,
        getEmpTotalTimeLoading: false,
        getEmpTotalTimeInfo: payload,
        getEmpTotalTimeError: "",
      };
    case EMPLOYEES_MANAGER_TOTAL_TIME_BY_RANGE_FAIL:
      return {
        ...state,
        getEmpTotalTimeLoading: false,
        getEmpTotalTimeError: payload,
        getEmpTotalTimeInfo: [],
      };
    default:
      return state;
  }
};